import { FileXlsIcon } from "@phosphor-icons/react/dist/csr/FileXls";
import type { ReactNode } from "react";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import { cn } from "@volca/ui/lib/utils";

const EMPTY_SHEET_DESCRIPTION = "There are no cells to show for this sheet.";

interface EmptySheetStateProps {
  title: string;
  description?: string;
  isFramed?: boolean;
  fillHeight?: boolean;
  action?: ReactNode;
}

export const EmptySheetState = ({
  title,
  description,
  isFramed = true,
  fillHeight = false,
  action,
}: EmptySheetStateProps) => (
  <Empty
    className={cn(
      emptyStateVariants({ layout: fillHeight ? "workspace" : "panel" }),
      {
        "rounded-xl border border-solid border-line bg-surface-raised":
          isFramed,
      },
    )}
  >
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <FileXlsIcon />
      </EmptyMedia>
      <EmptyTitle>{title}</EmptyTitle>
      {/* A description shows wherever it is given. Framed states keep their default
          line; unframed ones used to drop the prop on the floor, so callers were
          passing copy that never rendered. */}
      {(description ?? (isFramed ? EMPTY_SHEET_DESCRIPTION : null)) && (
        <EmptyDescription>
          {description ?? EMPTY_SHEET_DESCRIPTION}
        </EmptyDescription>
      )}
    </EmptyHeader>
    {action && <EmptyContent>{action}</EmptyContent>}
  </Empty>
);
